(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gw-rewards-page-hero"] && !Shopify.designMode) return;
  try {
    
  const placeholderBR = document.querySelector('.gw-widget-placeholder-BR');
  if (placeholderBR && (location.pathname.includes('rewards') || location.pathname.includes('loyalty'))) {
    placeholderBR.style.display = 'none';
  }

  } catch(e) { console.error(e); }
})();
})();
